// src/components/InstallBanner.js
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Share, PlusSquare } from "lucide-react";

const Banner = styled.div`
  width: 100%;
  background-color: #50B4C8;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-size: 0.9rem;
  box-sizing: border-box;
  flex-wrap: wrap;
  gap: 6px;
`;

const BannerText = styled.span`
  flex: 1;
  font-weight: 500;
  color: #ffffff;
`;

const InlineTip = styled.div`
  width: 100%;
  font-size: 0.85rem;
  color: #ffffff;
  font-weight: 500;
  padding: 2px 0 4px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
`;

const BannerButton = styled.button`
  background: #ffffff;
  color: #50B4C8;
  border: none;
  border-radius: 6px;
  padding: 6px 14px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  margin-left: 12px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const DismissButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0 0 0 10px;
  line-height: 1;
  flex-shrink: 0;
`;

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches;
}

export default function InstallBanner() {
  const [visible, setVisible] = useState(false);
  const [ios, setIos] = useState(false);
  const [showIOSTip, setShowIOSTip] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;
    if (localStorage.getItem("cwInstallDismissed")) return;

    const iosDevice = isIOS();
    setIos(iosDevice);
    setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem("cwInstallDismissed", "true");
    setVisible(false);
  };

  const handleInstall = async () => {
    const prompt = window.deferredPrompt;
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") {
      window.deferredPrompt = null;
      dismiss();
    }
  };

  if (!visible) return null;

  const iconStyle = { display: "inline-block", verticalAlign: "middle", margin: "0 4px", color: "#ffffff" };

  return (
    <Banner>
      <BannerText>📲 Add ClubWeek to your home screen</BannerText>
      {ios ? (
        <BannerButton onClick={() => setShowIOSTip((v) => !v)}>
          {showIOSTip ? "Got it" : "Show me"}
        </BannerButton>
      ) : (
        window.deferredPrompt ? (
          <BannerButton onClick={handleInstall}>Install</BannerButton>
        ) : null
      )}
      <DismissButton onClick={dismiss} aria-label="Dismiss">×</DismissButton>
      {ios && showIOSTip && (
        <InlineTip>
          Tap <Share size={16} style={iconStyle} /> Share then <PlusSquare size={16} style={iconStyle} /> Add to Home Screen
        </InlineTip>
      )}
    </Banner>
  );
}
